export default __webpack_public_path__ + "static/media/Rubik-Regular.da39336c.ttf";